export function OnOffSwitch({ checked, onChange, testid, disabled }) {
  return (
    <button type="button" role="switch" aria-checked={!!checked} disabled={disabled} onClick={() => onChange(!checked)} data-testid={testid}
      className={`relative inline-flex h-8 w-[74px] shrink-0 items-center rounded-full border-2 transition-colors disabled:opacity-50 ${checked ? "border-emerald-700 bg-emerald-600" : "border-slate-300 bg-slate-200"}`}>
      <span className={`pointer-events-none absolute text-[11px] font-bold tracking-wider ${checked ? "left-3 text-white" : "right-3 text-slate-600"}`}>{checked ? "ON" : "OFF"}</span>
      <span className={`pointer-events-none h-6 w-6 rounded-full bg-white shadow transition-transform ${checked ? "translate-x-[42px]" : "translate-x-[2px]"}`} />
    </button>
  );
}
